export default __webpack_public_path__ + "static/media/trr-event-music-mic.12e3dd54.png";